export default __webpack_public_path__ + "static/media/flash26.34403ebb.png";